import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box, Container, IconButton, Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import Input from '../Input';
import { ButtonCredit } from '../Simulator/ButtonCredit';

import { convertirAMoneda } from '../../utils/currency';
import { isGreaterThanOrEqualThanValue, isGreaterThanValue, isValidPercentage } from '../../utils/simulator.utils';

import styles from './useStyles';

import {
  CALC_MODE_CONDITIONS_EDITION,
  INPUT_NAME_DESEMBOLSO,
  INPUT_NAME_ENGANCHE,
  INPUT_NAME_MONTO_CREDITO,
  INPUT_SIMULATOR_MINIMUM_DESEMBOLSO_PERCENTAGE,
  INPUT_SIMULATOR_MINIMUN_ENGANCHE_PERCENTAGE,
  MINIMUM_CREDIT_VALUE,
} from '../../constants';
import { usePerfilador } from '../../hooks/usePerfilador';

export const CreditConditionsSimulator = ({
  isVivienda,
  onSubmit,
  initialValues,
  buttonTitle,
  hidePlazo,
  useDesembolsoMode,
}) => {
  const classes = styles();
  const {
    inputValue: precio,
    engancheRecursosPropios,
    engancheRecursosPropiosNumber,
    plazo,
    inputNumber: precioNumber,
    engancheNumber,
    plazoNumber,
    percentageEnganche,
    percentageEngancheRecursosPropios,
    pagoMensual,
    montoCredito,
    montoCreditoRangos,
    engancheMinimoRecursosPropiosPercentage,
    decreasePercentageEngancheRecursosPropios,
    increasePercentageEngancheRecursosPropios,
    // decreasePercentageEnganche,
    // increasePercentageEnganche,
    // enganche,
    // engancheMinimoPercentage: INPUT_SIMULATOR_MINIMUN_ENGANCHE_PERCENTAGE,
    montoGastosEscritura,
    onChange,
    onChangeEnganche,
    onChangePlazo,
    onChangeMontoCredito,
    // infonavit
    sueldoMensualBruto = null,
    montoMensual = null,
  } = usePerfilador({
    calcMode: CALC_MODE_CONDITIONS_EDITION,
    useDesembolsoMode,
    initialData: initialValues,
    engancheMinimoPercentage: INPUT_SIMULATOR_MINIMUN_ENGANCHE_PERCENTAGE,
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const storageData = {
      montoMensual,
      sueldoMensualBruto,
      importe: montoCredito,
      meses: plazoNumber * 12,
      aforo: (montoCredito / precioNumber).toFixed(4),
      enganche: engancheNumber,
      engancheRecursosPropios: engancheRecursosPropiosNumber,
      year: plazoNumber,
      plazo,
      mensualidad: pagoMensual,
      propietyValue: precioNumber,
      montoGastosEscritura,
      percentageEnganche,
    };
    onSubmit({ storageData, event });
  };

  const validateMaxMontoCredito = (inputValue) => {
    if (montoCreditoRangos.maximo === 0) return true;
    const message = `Valor no puede ser mayor a ${convertirAMoneda(montoCreditoRangos.maximo)}`;
    return isGreaterThanValue(montoCreditoRangos.maximo, inputValue, message);
  };

  return (
    <Container
      component="form"
      onSubmit={handleSubmit}
      method="post"
      autoComplete="off"
      className={classes.formContainer}
      disableGutters
      maxWidth={false}
    >
      <Box
        className={clsx(classes.innerContainer, {
          [classes.viviendaInnerContainer]: isVivienda,
        })}
      >
        <Box className={classes.firtInputElement}>
          <Input
            className={classes.inputPrecio}
            label={initialValues.precio.label}
            type={initialValues.precio.type}
            name={initialValues.precio.name}
            value={precio}
            required={initialValues.precio.required}
            isEmpty={initialValues.precio.isEmpty}
            validations={[
              (inputValue) => isGreaterThanOrEqualThanValue(
                inputValue,
                MINIMUM_CREDIT_VALUE,
                `Valor no puede ser menor a ${convertirAMoneda(
                  MINIMUM_CREDIT_VALUE,
                )}`,
              ),
            ]}
            onChange={onChange}
            clearable
          />
        </Box>
        <Box className={classes.firtInputElement}>
          {Object.keys(initialValues).includes(INPUT_NAME_ENGANCHE) && (
          <Input
            disabled={initialValues.enganche.disabled}
            className={classes.engancheInput}
            label={initialValues.enganche.label}
            type={initialValues.enganche.type}
            name={initialValues.enganche.name}
            value={engancheRecursosPropios}
            required={initialValues.enganche.required}
            isEmpty={initialValues.enganche.isEmpty}
            onChange={onChangeEnganche}
            error={initialValues.enganche.error}
            validations={[
              (inputValue) => isValidPercentage(
                inputValue,
                precioNumber,
                engancheMinimoRecursosPropiosPercentage,
                `Valor no puede ser menor a ${engancheMinimoRecursosPropiosPercentage}%`,
              ),
              (inputValue) => isGreaterThanValue(
                precioNumber,
                inputValue,
                'Enganche no puede ser mayor al precio',
              ),
            ]}
            endAdornment={(
              <Box className={classes.engancheContainer}>
                <IconButton
                  className={classes.removeButton}
                  onClick={() => {
                    decreasePercentageEngancheRecursosPropios();
                  }}
                >
                  <RemoveIcon size="small" />
                </IconButton>
                <Typography
                  className={clsx(classes.enganche, {
                    [classes.invalidate]:
                      percentageEngancheRecursosPropios
                      < engancheMinimoRecursosPropiosPercentage,
                  })}
                >
                  {`${percentageEngancheRecursosPropios}%`}
                </Typography>
                <IconButton
                  className={classes.addButton}
                  onClick={() => {
                    increasePercentageEngancheRecursosPropios();
                  }}
                >
                  <AddIcon size="small" />
                </IconButton>
              </Box>
                )}
          />
          )}
          {(Object.keys(initialValues).includes(INPUT_NAME_DESEMBOLSO) && useDesembolsoMode) && (
            <Box className={classes.precioContainer}>
              <Input
                disabled={initialValues.desembolso.disabled}
                className={classes.engancheInput}
                label={initialValues.desembolso.label}
                type={initialValues.desembolso.type}
                name={initialValues.desembolso.name}
                value={engancheRecursosPropios}
                required={initialValues.desembolso.required}
                isEmpty={initialValues.desembolso.isEmpty}
                onChange={onChangeEnganche}
                error={initialValues.desembolso.error}
                validations={[
                  (inputValue) => isValidPercentage(
                    inputValue,
                    initialValues.precio.value,
                    INPUT_SIMULATOR_MINIMUM_DESEMBOLSO_PERCENTAGE,
                    `Valor no puede ser menor a ${INPUT_SIMULATOR_MINIMUM_DESEMBOLSO_PERCENTAGE}%`,
                  ),
                  (inputValue) => isGreaterThanValue(
                    initialValues.precio.value,
                    inputValue,
                    'Enganche no puede ser mayor al precio',
                  ),
                ]}
                endAdornment={(
                  <Typography
                    className={clsx(classes.enganche, {
                      [classes.invalidate]:
                        percentageEnganche < INPUT_SIMULATOR_MINIMUM_DESEMBOLSO_PERCENTAGE,
                    })}
                  >
                    {`${percentageEnganche}%`}
                  </Typography>
                )}
              />
            </Box>
          )}
        </Box>
        {Object.keys(initialValues).includes(INPUT_NAME_MONTO_CREDITO) && (
          <Box className={classes.firtInputElement}>
            <Input
              disabled={initialValues[INPUT_NAME_MONTO_CREDITO].disabled}
              className={classes.engancheInput}
              label={initialValues[INPUT_NAME_MONTO_CREDITO].label}
              type={initialValues[INPUT_NAME_MONTO_CREDITO].type}
              name={initialValues[INPUT_NAME_MONTO_CREDITO].name}
              value={montoCredito}
              required={initialValues[INPUT_NAME_MONTO_CREDITO].required}
              isEmpty={initialValues[INPUT_NAME_MONTO_CREDITO].isEmpty}
              onChange={onChangeMontoCredito}
              error={initialValues[INPUT_NAME_MONTO_CREDITO].error}
              validations={[
                (inputValue) => isGreaterThanValue(
                  precioNumber,
                  inputValue,
                  'Valor no puede ser mayor al precio',
                ),
                (inputValue) => validateMaxMontoCredito(inputValue),
              ]}
              clearable
            />
          </Box>
        )}
        {hidePlazo ? null : (
          <Box className={classes.yearContainer}>
            <Input
              className={classes.inputYear}
              label={initialValues.year.label}
              type={initialValues.year.type}
              name={initialValues.year.name}
              value={plazo}
              required={initialValues.year.required}
              isEmpty={initialValues.year.isEmpty}
              onChange={onChangePlazo}
              fullWidth
              options={initialValues.year.options}
            />
          </Box>
        )}
      </Box>
      <Box className={classes.containerButton}>
        <ButtonCredit
          className={classes.button}
          variant="contained"
          type="submit"
        >
          {buttonTitle}
        </ButtonCredit>
      </Box>
    </Container>
  );
};

CreditConditionsSimulator.propTypes = {
  onSubmit: PropTypes.func,
  isVivienda: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  initialValues: PropTypes.object.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  hidePlazo: PropTypes.bool,
  useDesembolsoMode: PropTypes.bool,
};

CreditConditionsSimulator.defaultProps = {
  onSubmit: () => { },
  isVivienda: false,
  hidePlazo: false,
  useDesembolsoMode: false,
};
